import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as workspaces from '../../../../workspaces'
import * as conversation from '../conversation'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: conversation.RESOURCE.payload.dimension.partialId,
      partialId: conversation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Optional reference to a workspace that groups this conversation with others. Null for ungrouped conversations.',
    isOptional: true,
    name: 'Workspace',
    partialId: PartialId.Standard.create('workspace'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        workspaces.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
